<template>
    <div id="menu" :class="color">
        <b-container>
            <b-row>
                <b-col md="12">
                    <b-navbar toggleable="lg" type="light">
                        <b-navbar-brand><router-link :to="{ name: 'Home'}"><img class="logo" src="../assets/img_logo.svg" alt=""></router-link></b-navbar-brand>

                        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                        <b-collapse id="nav-collapse" is-nav>
                            <!-- Right aligned nav items -->
                            <b-navbar-nav class="ml-auto">
                                <router-link
                                    class="nav-link"
                                    :to="{
                                        name: 'Home',
                                        hash: '#aboutus'
                                    }"
                                >{{ $t('nav_menu.us') }}</router-link>
                                <router-link
                                    class="nav-link"
                                    :to="{
                                        name: 'Home',
                                        hash: '#productsandservices'
                                    }"
                                >{{ $t('nav_menu.products') }}</router-link>
                                <router-link
                                    class="nav-link"
                                    :to="{
                                        name: 'Home',
                                        hash: '#benefits'
                                    }"
                                >{{ $t('nav_menu.benefits') }}</router-link>  
                                <router-link
                                    class="nav-link"
                                    :to="{
                                        name: 'Blog'
                                    }"
                                >Blog</router-link> 
                                <router-link
                                    class="nav-link contact-menu"
                                    :to="{
                                        name: 'Home',
                                        hash: '#contact'
                                    }"
                                >{{ $t('nav_menu.contact') }}</router-link>        
                                <b-nav-item v-on:click="updateLocale($i18n.locale)" class="switch-lang">
                                    <div class="text-lang" v-if="$i18n.locale === 'es-MX'">ENG</div>
                                    <div class="text-lang" v-else>ESP</div>
                                </b-nav-item>
                            </b-navbar-nav>
                        </b-collapse>
                    </b-navbar>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
    export default {
        props: {
            color: {
                colorHead: String,
                default: 'white'
            }
        },
        methods: {
            updateLocale(newLang) {
                this.$i18n.locale = newLang ==='en-US' ? 'es-MX' : 'en-US' ;
                localStorage.setItem("lang", this.$i18n.locale)
            }
        }
    }
</script>

<style scoped>
#menu{
    position: fixed;
    width: 100%;
    z-index: 1000;
}
.white{
    background: #fff;
}

.transparent{
    background: transparent;
}
.ml-auto{
    margin-left: auto;
}
.nav-link{
    text-transform: uppercase;
    font-size: 16px;
    color: #503B2D;
}

.nav-link:focus,
.nav-link:hover,
.nav-link:active{
    color: #503B2D;
}
.switch-lang{
    background: #503B2D;
    border-radius: 30px;
    color: #fff;
    height: fit-content;
}
.switch-lang .text-lang{
    color: #fff;
}

.navbar-toggler,
.navbar-toggler:hover,
.navbar-toggler:focus,
.navbar-toggler:active{
    border: none;
    outline: 0 !important;
    box-shadow: none !important;
}
.navbar-expand-lg .navbar-nav .nav-link{
    padding-left: 30px;
    padding-right:30px;
}

.contact-menu{
    border: 1px solid #503B2D;
    border-radius: 30px;
    height: fit-content;
}

.switch-lang{
    margin-left: 20px;
    margin-right: 30px;
}

.switch-lang > .nav-link{
    padding-left: 20px !important;
    padding-right: 20px !important;
}
@media (max-width: 1600px){
    .logo{
        width: 300px;
    }
    .nav-link{
        font-size: 16px;
    }
}
@media (max-width: 1200px){
    .logo{
        width: 200px;
    }
}
@media (max-width: 992px){
    #menu{
        box-shadow: -1px 10px 29px -13px #503B2D;
        -webkit-box-shadow: -1px 10px 29px -13px #503B2D;
        -moz-box-shadow: -1px 10px 29px -13px #503B2D;
    }
    
    .container-fluid{
        padding-left: 0;
        padding-right: 0;
    }
    .navbar-nav{
        background: #fff;
    }
    .nav-link,
    .nav-link:focus,
    .nav-link:hover,
    .nav-link:active{
        color: #000;
    }
    .contact-menu,
    .switch-lang{
        margin-left: 30px;
        margin-right: 30px;
        margin-bottom: 10px;
    }
    .btn-menu{
        margin-left: 30px;
        margin-right: 30px;
    }
    .btn-menu a,
    .btn-menu a:hover,
    .btn-menu a:focus{
        color: #fff;
    }
}
@media (max-width: 768px){
  .logo{
    width: 150px;
  }
  
}
</style>